export const module = {
  info: {
    name: 'user-mrt-features',
    caption: 'user mrt features',
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  noRoutes: true,
}

export default module
